import { privateApi, API_CONFIG } from '../config/api';

class ProfileService {
  // Get user profile
  async getUserProfile() {
    try {
      const response = await privateApi.get('/v1/profile/');
      const data = response.data;
      const user = data.user || data;
      return {
        username: user.username || '',
        first_name: user.first_name || '',
        last_name: user.last_name || '',
        country: data.country || null,
      };
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }

  // Update user profile
  async updateUserProfile(userData) {
    try {
      const response = await privateApi.put(API_CONFIG.AUTH.USER, {
        username: userData.username,
        first_name: userData.first_name,
        last_name: userData.last_name
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }

  // Change password
  async changePassword(passwordData) {
    try {
      const response = await privateApi.post('/v1/auth/password/change/', {
        old_password: passwordData.old_password,
        new_password1: passwordData.new_password1,
        new_password2: passwordData.new_password2,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }

  // Update user settings
  async updateSettings(settingsData) {
    try {
      const response = await privateApi.post('/v1/profile/settings/', settingsData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }

  // Check 2FA status
  async check2FA() {
    try {
      const response = await privateApi.post(API_CONFIG.AUTH.CHECK_2FA);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }

  // Enable 2FA
  async enable2FA(secretcode) {
    try {
      const response = await privateApi.post(`${API_CONFIG.AUTH.ENABLE_2FA}?secretcode=${secretcode}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }

  // Disable 2FA
  async disable2FA(secretcode) {
    try {
      const response = await privateApi.post(`${API_CONFIG.AUTH.DISABLE_2FA}?secretcode=${secretcode}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }

  // Update auto logout setting
  async updateAutoLogout(minutes) {
    try {
      const response = await privateApi.post('/v1/profile/auto-logout/', {
        minutes: minutes,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }

  // Update default interface setting
  async updateDefaultInterface(interfaceType) {
    try {
      const response = await privateApi.post('/v1/profile/default-interface/', {
        interface: interfaceType,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }

  // Update IP change notification setting
  async updateIPNotification(enabled) {
    try {
      const response = await privateApi.post('/v1/profile/ip-notification/', {
        enabled: enabled,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }

  // Update login failure notification setting
  async updateLoginFailureNotification(enabled) {
    try {
      const response = await privateApi.post('/v1/profile/login-failure-notification/', {
        enabled: enabled,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
}

export default new ProfileService();
